import type { StyleRule } from '@archipro-design/aria';
import { messageTooltipContentClassName } from '@archipro-design/aria';
import { hex2rgba } from '~/utils/colorHelper';

export const ActionButton: StyleRule = ({ theme }) => ({
    boxShadow: `0px 14px 24px 2px ${hex2rgba(
        theme.siteVariables.colors.primitive.black,
        0.08,
    )}`,
});

export const TooltipContent: StyleRule = ({ theme }) => ({
    zIndex: theme.siteVariables.zIndexes.foreground,
    [`&.${messageTooltipContentClassName}`]: {
        maxWidth: 'unset',
        textAlign: 'center',
    },
});

export const Copied: StyleRule = ({ theme }) => ({
    fill: theme.siteVariables.colors.success['200'],
});
